import "./App.css";
import "./styles/home.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import ScrollHandler from "./components/scroll_handler";

import HomeScreen from "./screens/home_screen";
import XlpForSchools from "./screens/xlp_for_schools_screen";
import XlpIndividualStudents from "./screens/xlp_individual_students_screen";
import ChannelWithUs from "./screens/channel_with_us_screen";
import ProductsReturnsScreen from "./screens/products_returns_screen";
import ProductsShippingScreen from "./screens/products_shipping_screen";
import ProductCancellationScreen from "./screens/products_cancellation_screen";
import ContactScreen from "./screens/contact_screen";
import XlpWorkshops from "./screens/xlp_workshops";
import WorkInProgressScreen from "./screens/wip_screen";
import SignUp from "./screens/sign_up_screen";
import Login from "./screens/login_screen";
import ShopNowScreen from "./screens/shop_now_screen";
import PurchaseScreen from "./screens/purchase_screen";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Safely reads your standard "user" key from local storage on load
    const user = JSON.parse(localStorage.getItem("user"));
    setIsLoggedIn(!!user);
  }, []);

  return (
    <>
      <BrowserRouter>
        <ScrollHandler />

        <Routes>
          <Route
            path="/"
            element={<HomeScreen isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/xlp_for_schools_screen"
            element={<XlpForSchools isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/xlp_individual_students_screen"
            element={<XlpIndividualStudents isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/channel_with_us_screen"
            element={<ChannelWithUs isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/products_returns_screen"
            element={<ProductsReturnsScreen isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/products_shipping_screen"
            element={<ProductsShippingScreen isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/products_cancellation_screen"
            element={<ProductCancellationScreen isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/contact_screen"
            element={<ContactScreen isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/xlp_workshops"
            element={<XlpWorkshops isLoggedIn={isLoggedIn} />}
          ></Route>

          {/* TRAP 2 FIXED: Path matches exactly what the button targets */}
          <Route
            path="/wip"
            element={<WorkInProgressScreen isLoggedIn={isLoggedIn} />}
          ></Route>

          <Route path="/sign_up_screen" element={<SignUp />}></Route>
          <Route path="/login_screen" element={<Login />}></Route>

          <Route
            path="/shop_now_screen"
            element={<ShopNowScreen isLoggedIn={isLoggedIn} />}
          ></Route>
          <Route
            path="/purchase_screen"
            element={<PurchaseScreen isLoggedIn={isLoggedIn} />}
          ></Route>
        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          pauseOnHover
        />
      </BrowserRouter>
    </>
  );
}

export default App;
